import React from 'react'
import PlusSvg from 'images/modules/Shared/i-plus-peach.svg?raw'

export { default as PlusPeachUrl } from 'images/modules/Shared/i-plus-peach.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: PlusSvg}} />
)
